export const Colors = {
  black: "#333333",
  white: "#FFFFFF",
  blue: "#04689b",
  lightBlue: "#CFEFFC",
  darkBlue: "#063346",
  green: "#12890e",
  gray: "#F7F7F7",
  darkGray: "#D6D7D9",
};
